// Lakai — site-wide cart drawer (extracted from p7-sale.js, 2026-07-03 rebrand).
// Loaded by sections/p7-header.liquid on every page. Talks to the real Shopify
// AJAX cart (/cart/add.js, /cart.js, /cart/change.js, /checkout).
//
// Public contract (used by p7-product.liquid and p7-sale.js):
//   window.P7Cart = {
//     add(variantId, qty, properties) -> Promise (refreshes + opens the drawer; rejects on failure),
//     open(), close(), refresh() -> Promise
//   }
(function () {
  'use strict';
  if (window.__p7CartInit) return;
  window.__p7CartInit = true;

  var cart = { items: [], item_count: 0, total_price: 0 };
  var catalog = null; // homepage-only product JSON for the add-ons row
  var productCache = {};

  function $(id) { return document.getElementById(id); }

  // Visible line item properties (2026-10-13): "Pre-order: Ships late
  // November" must show in the bag. Keys starting "_" are internal and stay
  // hidden, which is Shopify's own convention for checkout too.
  function visibleProps(item) {
    var props = item && item.properties;
    if (!props || typeof props !== 'object') return '';
    return Object.keys(props).filter(function (k) {
      return k.charAt(0) !== '_' && props[k] != null && String(props[k]) !== '';
    }).map(function (k) {
      return '<p class="p7-cart-drawer__item-prop">' + escapeHtml(k) + ': ' + escapeHtml(props[k]) + '</p>';
    }).join('');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function shopifyCrop(url, w, h) {
    if (!url) return url;
    return url.replace(/\.(jpe?g|png|webp)(\?.*)?$/i, '_' + w + 'x' + h + '_crop_center.$1$2');
  }

  function p7moneyCents(v) {
    // Cents (2026-10-15): round to 2dp; whole prices stay bare, fractional
    // ones keep their cents, so the bag matches what checkout charges.
    var n = Math.round((Number(v) || 0) * 100) / 100;
    var w = Math.floor(Math.abs(n));
    var c = Math.round((Math.abs(n) - w) * 100);
    var s = String(w).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (c > 0) s += '.' + (c < 10 ? '0' : '') + c;
    return (n < 0 ? '-' : '') + '$' + s;
  }
  function dollars(amount) { return p7moneyCents(amount); }
  function money(cents) { return dollars((Number(cents) || 0) / 100); }
  function priceText(value) {
    if (typeof value === 'number') return money(value);
    var clean = String(value == null ? '' : value).replace(/[^0-9.]/g, '');
    return clean ? dollars(clean) : '$0';
  }

  function linePriceHtml(item) {
    var original = Number(item && item.original_line_price) || 0;
    var final = Number(item && item.final_line_price) || 0;
    if (original > final) {
      return '<s>' + money(original) + '</s><span>' + money(final) + '</span>';
    }
    return '<span>' + money(final) + '</span>';
  }

  function readCatalog() {
    var el = $('p7-product-data');
    if (!el) return null;
    try { return (JSON.parse(el.textContent).products || null); }
    catch (e) { return null; }
  }

  function savedShoeSizes() {
    try {
      var raw = window.sessionStorage && window.sessionStorage.getItem('p7_size_prefs_session');
      var prefs = raw ? JSON.parse(raw) : null;
      return prefs && Array.isArray(prefs.s) ? prefs.s.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function readRecentlyViewed() {
    try {
      if (!window.localStorage) return [];
      var items = JSON.parse(window.localStorage.getItem('p7_recently_viewed_products') || '[]') || [];
      return items.filter(function (item) { return item && item.handle; });
    } catch (e) {
      return [];
    }
  }

  function variantForProduct(p, requireSavedSize) {
    var variants = (p && p.variants) || [];
    var live = variants.filter(function (v) { return Number(v.inventory) > 0; });
    if (!live.length) return null;
    var saved = savedShoeSizes();
    for (var i = 0; i < saved.length; i += 1) {
      for (var j = 0; j < live.length; j += 1) {
        if (String(live[j].size || '').trim() === String(saved[i] || '').trim()) return live[j];
      }
    }
    if (requireSavedSize && saved.length) return null;
    return live[0];
  }

  function productHandleFromItem(item) {
    if (item && item.handle) return String(item.handle);
    var raw = String((item && item.url) || '');
    return raw.split('/products/').pop().split('?')[0].split('#')[0];
  }

  function fetchProduct(handle) {
    handle = String(handle || '').trim();
    if (!handle) return Promise.reject(new Error('Missing product handle.'));
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
      }).then(function (r) {
        if (!r.ok) throw new Error('product fetch failed: ' + r.status);
        return r.json();
      });
    }
    return productCache[handle];
  }

  function optionName(option) {
    return String((option && (option.name || option)) || '').toLowerCase();
  }

  function sizeOptionIndex(product) {
    var options = (product && product.options) || [];
    for (var i = 0; i < options.length; i += 1) {
      if (optionName(options[i]).indexOf('size') >= 0) return i;
    }
    return -1;
  }

  function variantOptionValue(variant, index) {
    return variant ? variant['option' + (index + 1)] : null;
  }

  function availableVariants(product) {
    return ((product && product.variants) || []).filter(function (v) {
      return v && v.id && v.available !== false;
    });
  }

  function preferredVariantFromProduct(product) {
    var live = availableVariants(product);
    if (!live.length) return null;
    var sizeIndex = sizeOptionIndex(product);
    var saved = savedShoeSizes();
    if (sizeIndex >= 0 && saved.length) {
      for (var i = 0; i < saved.length; i += 1) {
        for (var j = 0; j < live.length; j += 1) {
          if (String(variantOptionValue(live[j], sizeIndex) || '').trim() === String(saved[i] || '').trim()) return live[j];
        }
      }
    }
    return live[0];
  }

  function sameNonSizeOptions(a, b, sizeIndex) {
    if (!a || !b) return false;
    for (var i = 0; i < 3; i += 1) {
      if (i === sizeIndex) continue;
      var av = variantOptionValue(a, i);
      var bv = variantOptionValue(b, i);
      if (av != null && bv != null && String(av) !== String(bv)) return false;
    }
    return true;
  }

  function imageKey(url) {
    return String(url || '')
      .split('?')[0]
      .split('/')
      .pop()
      .replace(/_\d+x\d+(_crop_center)?(?=\.)/i, '')
      .toLowerCase();
  }

  function recommendationImage(product) {
    return (product && (product.image || product.featured_image || (product.images && product.images[0]))) || '';
  }

  function productTypeText(product) {
    return String((product && (product.type || product.product_type || product.category)) || '').toLowerCase();
  }

  function looksLikeShoe(product) {
    var hay = productTypeText(product) + ' ' + String((product && product.title) || '').toLowerCase();
    return hay.indexOf('shoe') >= 0 ||
      hay.indexOf('cambridge') >= 0 ||
      hay.indexOf('telford') >= 0 ||
      hay.indexOf('manchester') >= 0 ||
      hay.indexOf('essex') >= 0 ||
      hay.indexOf('conrad') >= 0 ||
      hay.indexOf('payload') >= 0;
  }

  function hasSavedShoeVariant(product) {
    if (!looksLikeShoe(product)) return false;
    var saved = savedShoeSizes();
    if (!saved.length) return availableVariants(product).length > 0;
    var sizeIndex = sizeOptionIndex(product);
    if (sizeIndex < 0) return false;
    return availableVariants(product).some(function (v) {
      return saved.indexOf(String(variantOptionValue(v, sizeIndex))) >= 0;
    });
  }

  function anchoredVariantForRecommendation(full, recommendation) {
    var target = imageKey(recommendationImage(recommendation));
    var variants = availableVariants(full);
    if (target) {
      for (var i = 0; i < variants.length; i += 1) {
        var img = variants[i].featured_image;
        var src = img && (img.src || img.url);
        if (src && imageKey(src) === target) return variants[i];
      }
    }
    return null;
  }

  function open() {
    var d = $('cart-drawer');
    if (!d) return;
    if (window.P7Menu && window.P7Menu.close) window.P7Menu.close();
    document.documentElement.classList.add('p7-cart-open', 'p7-no-scroll');
    d.hidden = false;
    document.dispatchEvent(new CustomEvent('p7:cart-open'));
  }

  function close() {
    var d = $('cart-drawer');
    if (d) d.hidden = true;
    document.documentElement.classList.remove('p7-cart-open', 'p7-no-scroll');
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; updateUI(); })
      .catch(function (e) { console.error(e); updateUI(); });
  }

  function add(variantId, qty, properties) {
    var payload = { id: Number(variantId), quantity: qty || 1 };
    if (properties && typeof properties === 'object') payload.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (!res.ok) throw new Error('cart add failed: ' + res.status);
      return refresh();
    }).then(function () { open(); });
  }

  function addItems(items) {
    var payload = {
      items: (items || []).map(function (item) {
        var line = {
          id: Number(item.id),
          quantity: item.quantity || 1,
        };
        if (item.properties && typeof item.properties === 'object') line.properties = item.properties;
        if (item.selling_plan) line.selling_plan = item.selling_plan;
        return line;
      }).filter(function (item) { return item.id; }),
    };
    if (!payload.items.length) return Promise.reject(new Error('No cart items to add.'));

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (!res.ok) throw new Error('cart add failed: ' + res.status);
      return refresh();
    }).then(function () { open(); });
  }

  function change(variantId, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(variantId), quantity: qty }),
    }).then(refresh).catch(function (e) { console.error(e); });
  }

  function replaceLineVariant(lineKey, variantId, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(lineKey), quantity: 0 }),
    }).then(function (res) {
      if (!res.ok) throw new Error('cart line remove failed: ' + res.status);
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 }),
      });
    }).then(function (res) {
      if (!res.ok) throw new Error('cart line replace failed: ' + res.status);
      return refresh();
    }).then(function () { open(); });
  }

  function hydrateLineTools(container) {
    var handle = container.getAttribute('data-product-handle');
    var lineKey = container.getAttribute('data-line-key');
    var variantId = container.getAttribute('data-variant-id');
    var qty = parseInt(container.getAttribute('data-line-qty'), 10) || 1;

    fetchProduct(handle).then(function (product) {
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var current = variants.filter(function (v) { return String(v.id) === String(variantId); })[0];
      var sizeIndex = sizeOptionIndex(product);
      if (!current || sizeIndex < 0) return;

      var seen = {};
      var choices = variants.filter(function (v) {
        return sameNonSizeOptions(current, v, sizeIndex);
      }).map(function (v) {
        var size = variantOptionValue(v, sizeIndex);
        if (!size || seen[size]) return null;
        seen[size] = true;
        return {
          id: v.id,
          size: size,
          available: v.available !== false,
          selected: String(v.id) === String(current.id),
        };
      }).filter(Boolean);

      if (choices.length < 2) return;

      var label = document.createElement('span');
      label.className = 'p7-cart-drawer__line-label';
      label.textContent = 'Size';

      var select = document.createElement('select');
      select.className = 'p7-cart-drawer__size-select';
      select.setAttribute('aria-label', 'Change size for ' + (product.title || 'cart item'));
      choices.forEach(function (choice) {
        var option = document.createElement('option');
        option.value = String(choice.id);
        option.textContent = choice.size;
        option.disabled = !choice.available;
        if (choice.selected) option.selected = true;
        select.appendChild(option);
      });
      select.addEventListener('change', function () {
        if (!select.value || String(select.value) === String(current.id)) return;
        select.disabled = true;
        replaceLineVariant(lineKey, select.value, qty).catch(function (e) {
          console.error(e);
          select.disabled = false;
        });
      });

      container.appendChild(label);
      container.appendChild(select);
    }).catch(function (e) {
      console.error(e);
    });
  }

  // Bag quantity (2026-10-14): minus / plus on each line. /cart/change.js
  // takes the line key; at quantity 1, minus removes the line. When Shopify
  // refuses (more than the stock of a size, a B2B quantity rule) the cart
  // keeps its count and the line says why instead of silently doing nothing.
  function stepLine(btn) {
    var row = btn.closest('[data-qty-line]');
    if (!row || row.getAttribute('aria-busy') === 'true') return;
    var key = row.getAttribute('data-qty-line');
    var qty = Math.max(0, (parseInt(row.getAttribute('data-qty'), 10) || 0) + Number(btn.getAttribute('data-qty-step')));
    var unlock = function () {
      row.removeAttribute('aria-busy');
      row.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
    };
    row.setAttribute('aria-busy', 'true');
    row.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: qty }),
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (body) {
        if (res.ok) return refresh();
        var msg = (body && (body.description || body.message)) || 'That quantity is not available.';
        return refresh().then(function () {
          var note = null;
          document.querySelectorAll('[data-qty-line]').forEach(function (r) {
            if (r.getAttribute('data-qty-line') === key) note = r.querySelector('[data-qty-note]');
          });
          if (note) { note.textContent = msg; note.hidden = false; }
        });
      });
    }).catch(function (e) { console.error(e); unlock(); });
  }

  function updateUI() {
    var countEl = $('cart-count');
    if (countEl) {
      var prev = parseInt(countEl.textContent, 10) || 0;
      countEl.textContent = cart.item_count || 0;
      var square = document.querySelector('[data-cart-square]');
      if (square) {
        square.classList.toggle('is-filled', (cart.item_count || 0) > 0);
        if ((cart.item_count || 0) > prev) {
          square.classList.add('is-bumped');
          setTimeout(function () { square.classList.remove('is-bumped'); }, 180);
        }
      }
    }
    var items = $('cart-items');
    if (!items) return;
    if (!cart.items || cart.items.length === 0) {
      items.innerHTML = '<p class="p7-cart-drawer__empty">Your cart is empty.<br>Time to grab some Lakais.</p>';
    } else {
      items.innerHTML = cart.items.map(function (i) {
        var img = i.image ? shopifyCrop(i.image, 200, 200) : '';
        var size = i.variant_title || '';
        var itemUrl = i.url || ('/products/' + i.handle);
        return [
          '<div class="p7-cart-drawer__item">',
            '<a class="p7-cart-drawer__item-image" href="' + escapeHtml(itemUrl) + '" aria-label="View ' + escapeHtml(i.product_title) + '"><img src="' + escapeHtml(img) + '" alt="' + escapeHtml(i.product_title) + '"></a>',
            '<div>',
              '<a class="p7-cart-drawer__item-title" href="' + escapeHtml(itemUrl) + '">' + escapeHtml(i.product_title) + '</a>',
              '<p class="p7-cart-drawer__item-meta">' + escapeHtml(size) + '</p>',
              visibleProps(i),
              '<div class="p7-cart-drawer__line-tools" data-line-tools data-line-key="' + escapeHtml(i.key || i.variant_id) + '" data-product-handle="' + escapeHtml(productHandleFromItem(i)) + '" data-variant-id="' + escapeHtml(i.variant_id) + '" data-line-qty="' + escapeHtml(i.quantity) + '"></div>',
              '<div class="p7-cart-drawer__item-actions">',
                '<a href="' + escapeHtml(itemUrl) + '">View</a>',
                '<button class="p7-cart-drawer__item-remove" data-remove="' + escapeHtml(i.key || i.variant_id) + '">Remove</button>',
              '</div>',
            '</div>',
            '<div class="p7-cart-drawer__item-price">' + linePriceHtml(i),
              '<div class="p7-cart-drawer__qty-row" data-qty-line="' + escapeHtml(i.key || i.variant_id) + '" data-qty="' + escapeHtml(i.quantity) + '">',
                '<div class="p7-cart-drawer__qty">',
                  '<button type="button" class="p7-cart-drawer__qty-btn" data-qty-step="-1" aria-label="' + escapeHtml((i.quantity > 1 ? 'One less ' : 'Remove ') + i.product_title) + '">&minus;</button>',
                  '<span class="p7-cart-drawer__qty-n" aria-label="Quantity ' + escapeHtml(i.quantity) + '">' + escapeHtml(i.quantity) + '</span>',
                  '<button type="button" class="p7-cart-drawer__qty-btn" data-qty-step="1" aria-label="' + escapeHtml('One more ' + i.product_title) + '">+</button>',
                '</div>',
                '<span class="p7-cart-drawer__qty-note" data-qty-note role="status" hidden></span>',
              '</div>',
            '</div>',
          '</div>',
        ].join('');
      }).join('');
      items.querySelectorAll('[data-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () { change(btn.dataset.remove, 0); });
      });
      items.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () { stepLine(btn); });
      });
      items.querySelectorAll('[data-line-tools]').forEach(function (container) {
        hydrateLineTools(container);
      });
    }
    var sub = $('cart-subtotal');
    if (sub) sub.textContent = money(cart.total_price || 0);
    renderRecommend();
  }

  // "You may also like" carousel. On the homepage it sources the in-page
  // catalog JSON (no extra request, supports single-variant quick-add);
  // everywhere else it falls back to Shopify's product recommendations API
  // keyed off the first line item, so the row works site-wide.
  var recCache = { key: null, products: null };

  function recCard(title, imgUrl, priceText, actionLabel, onAction, onView, optionEl) {
    var card = document.createElement('article');
    card.className = 'p7-cart-rec';
    var media = document.createElement(onView ? 'button' : 'span');
    if (onView) {
      media.type = 'button';
      media.className = 'p7-cart-rec__media';
      media.setAttribute('aria-label', 'View ' + title);
      media.addEventListener('click', onView);
    } else {
      media.className = 'p7-cart-rec__media';
    }
    var im = document.createElement('img');
    im.className = 'p7-cart-rec__img';
    im.loading = 'lazy';
    im.alt = title;
    im.src = imgUrl || '';
    media.appendChild(im);
    var t = document.createElement('span');
    t.className = 'p7-cart-rec__title';
    t.textContent = title;
    var pr = document.createElement('span');
    pr.className = 'p7-cart-rec__price';
    pr.textContent = priceText;
    var action = document.createElement('button');
    action.type = 'button';
    action.className = 'p7-cart-rec__add';
    action.textContent = actionLabel || 'Add to cart';
    action.addEventListener('click', function () {
      action.disabled = true;
      Promise.resolve(onAction && onAction()).catch(function (e) {
        console.error(e);
      }).then(function () {
        action.disabled = false;
      });
    });
    card.appendChild(media);
    card.appendChild(t);
    card.appendChild(pr);
    if (optionEl) card.appendChild(optionEl);
    card.appendChild(action);
    return card;
  }

  function productRecCard(p, label) {
    var isShoe = String((p && p.type) || '').toLowerCase() === 'shoe';
    var variant = variantForProduct(p, isShoe);
    if (!variant) return null;
    var live = ((p && p.variants) || []).filter(function (v) { return Number(v.inventory) > 0; });
    var select = null;
    if (live.length > 1) {
      select = document.createElement('select');
      select.className = 'p7-cart-rec__size';
      select.setAttribute('aria-label', 'Choose size for ' + p.title);
      live.forEach(function (v) {
        var option = document.createElement('option');
        option.value = String(v.id);
        option.textContent = v.size || 'Default';
        if (String(v.id) === String(variant.id)) option.selected = true;
        select.appendChild(option);
      });
    }
    return recCard(
      p.title,
      p.image ? shopifyCrop(p.image, 200, 200) : '',
      dollars(p.sale_price),
      label || 'Add to cart',
      function () {
        var selectedId = select && select.value ? select.value : variant.id;
        return add(selectedId, 1);
      },
      function () { window.location.href = p.url || ('/products/' + encodeURIComponent(p.handle)); },
      select
    );
  }

  function fullProductRecCard(p) {
    var handle = String((p && (p.handle || p.url)) || '').split('/products/').pop().split('?')[0];
    if (!handle) return Promise.resolve(null);

    return fetchProduct(handle).then(function (full) {
      var selectedId = null;
      var select = document.createElement('select');
      select.className = 'p7-cart-rec__size';
      select.setAttribute('aria-label', 'Choose size for ' + (p.title || full.title));
      select.hidden = true;
      var sizeIndex = sizeOptionIndex(full);
      var live = availableVariants(full);
      var anchor = anchoredVariantForRecommendation(full, p);
      var preferred = anchor || preferredVariantFromProduct(full) || live[0];
      if (preferred) selectedId = preferred.id;
      if (sizeIndex >= 0 && !anchor) {
        return null;
      }
      if (!preferred || !preferred.id) return null;

      if (sizeIndex >= 0 && live.length > 1) {
        var seen = {};
        var saved = savedShoeSizes();
        var sizeChoices = live.filter(function (v) {
          return sameNonSizeOptions(preferred, v, sizeIndex);
        }).map(function (v) {
          var size = variantOptionValue(v, sizeIndex);
          if (!size || seen[size]) return null;
          seen[size] = true;
          return { id: v.id, size: size };
        }).filter(Boolean);

        if (saved.length) {
          var savedChoice = null;
          for (var s = 0; s < saved.length; s += 1) {
            savedChoice = sizeChoices.filter(function (v) { return String(v.size) === String(saved[s]); })[0];
            if (savedChoice) break;
          }
          if (!savedChoice) return null;
          selectedId = savedChoice.id;
        }
        if (sizeChoices.length > 1) {
          sizeChoices.forEach(function (v) {
            var option = document.createElement('option');
            option.value = String(v.id);
            option.textContent = v.size;
            if (String(v.id) === String(selectedId)) option.selected = true;
            select.appendChild(option);
          });
          select.hidden = false;
          select.addEventListener('change', function () { selectedId = select.value; });
        }
      }

      return recCard(
        p.title || full.title,
        recommendationImage(p) ? shopifyCrop(recommendationImage(p), 200, 200) : '',
        priceText(p.price || full.price),
        'Add to cart',
        function () {
          if (selectedId) return add(selectedId, 1);
          return Promise.resolve();
        },
        function () { window.location.href = p.url || full.url || ('/products/' + handle); },
        select.hidden ? null : select
      );
    }).catch(function (e) {
      console.error(e);
      return null;
    });
  }

  function isTee(p) {
    var hay = ((p && p.category) || '') + ' ' + ((p && p.title) || '');
    hay = hay.toLowerCase();
    return hay.indexOf('t-shirt') >= 0 || hay.indexOf('tee') >= 0;
  }

  function isSock(p) {
    var hay = ((p && p.category) || '') + ' ' + ((p && p.title) || '');
    return hay.toLowerCase().indexOf('sock') >= 0;
  }

  function assignCartRecsTest() {
    try {
      if (!window.localStorage) return 'views';
      var key = 'p7_cart_recs_test';
      var value = window.localStorage.getItem(key);
      if (value === 'views' || value === 'shopify') return value;
      value = Math.random() < 0.5 ? 'views' : 'shopify';
      window.localStorage.setItem(key, value);
      return value;
    } catch (e) {
      return 'views';
    }
  }

  function emitCartRecsEvent(variant) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'p7_cart_recs_variant',
        cart_recs_variant: variant,
      });
    } catch (e) {}
  }

  function prioritizedCatalogRecs(products, limit) {
    var chosen = [];
    var used = {};
    function take(match) {
      for (var i = 0; i < products.length; i += 1) {
        var p = products[i];
        if (!used[p.id] && match(p)) {
          chosen.push(p);
          used[p.id] = true;
          return;
        }
      }
    }
    take(isTee);
    take(isSock);
    products.forEach(function (p) {
      if (chosen.length >= limit) return;
      if (!used[p.id]) chosen.push(p);
    });
    return chosen.slice(0, limit);
  }

  function prioritizedViewedRecs(products, limit) {
    var chosen = [];
    var used = {};
    var viewed = readRecentlyViewed();
    var byHandle = {};
    products.forEach(function (p) { byHandle[p.handle] = p; });
    viewed.forEach(function (view) {
      var p = byHandle[view.handle];
      if (p && !used[p.id] && chosen.length < limit) {
        chosen.push(p);
        used[p.id] = true;
      }
    });
    if (chosen.length < limit) {
      prioritizedCatalogRecs(products.filter(function (p) { return !used[p.id]; }), limit - chosen.length).forEach(function (p) {
        chosen.push(p);
      });
    }
    return chosen.slice(0, limit);
  }

  function renderViewedApiRecs(inCart, limit) {
    var viewed = readRecentlyViewed().filter(function (item) {
      return item && item.handle && !inCart[item.id];
    }).slice(0, 12);
    if (!viewed.length) return Promise.resolve([]);
    return Promise.all(viewed.map(function (item) {
      return fetchProduct(item.handle).then(function (full) {
        if (inCart[full.id]) return null;
        var merged = {
          id: full.id,
          handle: item.handle,
          url: item.url || full.url || ('/products/' + item.handle),
          title: item.title || full.title,
          image: item.image || recommendationImage(full),
          price: item.price || full.price,
          type: item.type || full.type || full.product_type,
        };
        var priority = hasSavedShoeVariant(full) ? 0 : (looksLikeShoe(full) ? 3 : (isTee(merged) || isSock(merged) ? 1 : 2));
        return fullProductRecCard(merged).then(function (card) {
          return card ? { card: card, priority: priority } : null;
        });
      }).catch(function () {
        return null;
      });
    })).then(function (results) {
      return results.filter(Boolean).sort(function (a, b) {
        return a.priority - b.priority;
      }).map(function (item) {
        return item.card;
      }).slice(0, limit);
    });
  }

  function addApiProduct(p) {
    var handle = String((p && (p.handle || p.url)) || '').split('/products/').pop().split('?')[0];
    if (!handle) return Promise.reject(new Error('Missing product handle for cart recommendation.'));
    return fetchProduct(handle).then(function (full) {
      var v = preferredVariantFromProduct(full);
      if (!v || !v.id) throw new Error('No available variant for cart recommendation.');
      return add(v.id, 1);
    });
  }

  function renderRecommend() {
    var wrap = $('cart-recommend');
    var row = $('cart-recommend-row');
    if (!wrap || !row) return;
    var inCart = {};
    (cart.items || []).forEach(function (i) { inCart[i.product_id] = true; });
    var testVariant = assignCartRecsTest();
    emitCartRecsEvent(testVariant);

    if (catalog === null) catalog = readCatalog() || [];
    if (catalog.length) {
      var limit = cart.items && cart.items.length ? 6 : 4;
      var candidates = catalog.filter(function (p) {
        return !inCart[p.id] && p.variants && p.variants.some(function (v) { return v.inventory > 0; });
      });
      var recs = testVariant === 'views' ? prioritizedViewedRecs(candidates, limit) : prioritizedCatalogRecs(candidates, limit);
      paint(recs.map(function (p) {
        return productRecCard(p, 'Add to cart');
      }).filter(Boolean));
      return;
    }

    if (!cart.items || cart.items.length === 0) {
      wrap.hidden = true;
      return;
    }

    if (testVariant === 'views') {
      renderViewedApiRecs(inCart, 6).then(function (cards) {
        if (cards.length) paint(cards);
        else renderShopifyApiRecs();
      }).catch(renderShopifyApiRecs);
      return;
    }

    renderShopifyApiRecs();

    function renderShopifyApiRecs() {
      var pid = cart.items[0].product_id;
    if (recCache.key === pid && recCache.products) {
      fromApi(recCache.products).then(paint);
      return;
    }
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=8', {
      headers: { Accept: 'application/json' },
    }).then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        recCache = { key: pid, products: d.products || [] };
        fromApi(recCache.products).then(paint);
      })
      .catch(function () { wrap.hidden = true; });
    }

    function fromApi(products) {
      return Promise.all(products.filter(function (p) { return !inCart[p.id] && p.available !== false; })
        .slice(0, 10)
        .map(function (p) {
          return fullProductRecCard(p);
        })).then(function (cards) {
          return cards.filter(Boolean).slice(0, 6);
        });
    }

    function paint(cardEls) {
      while (row.firstChild) row.removeChild(row.firstChild);
      if (!cardEls.length) { wrap.hidden = true; return; }
      cardEls.forEach(function (el) { row.appendChild(el); });
      wrap.hidden = false;
    }
  }

  function wire() {
    var btn = $('cart-btn');
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
    var closeBtn = $('cart-close');
    if (closeBtn) closeBtn.addEventListener('click', close);
    var backdrop = $('cart-backdrop');
    if (backdrop) backdrop.addEventListener('click', close);
    var checkout = document.querySelector('#cart-drawer .p7-cart-drawer__checkout');
    if (checkout) checkout.addEventListener('click', function () { window.location.href = '/checkout'; });
    document.addEventListener('keydown', function (e) {
      var d = $('cart-drawer');
      if (e.key === 'Escape' && d && !d.hidden) close();
    });
  }

  window.P7Cart = { add: add, addItems: addItems, open: open, close: close, refresh: refresh };

  wire();
  refresh();
  // bfcache restore: repaint the badge with the real cart state.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('shopify:section:load', function () { wire(); updateUI(); });
})();
